import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { UI_KENDO } from '@maximizer/core/shared/ui/kendo';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOG } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'maximizer-outlook-onboarding-remind-later',
  template: `
    <kendo-dialog [width]="256">
      <div class="py-2">
        <p class="text-body">
          {{ 'outlook.onboarding.later.message' | translate }}
        </p>
        <div class="flex justify-end">
          <button
            kendoButton
            themeColor="primary"
            class="uppercase"
            (click)="this.showRemindLater.emit(false)"
          >
            {{ 'outlook.buttons.ok' | translate }}
          </button>
        </div>
      </div>
    </kendo-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [KENDO_BUTTON, KENDO_DIALOG, TranslatePipe, UI_KENDO],
})
export class RemindLaterComponent {
  showRemindLater = output<boolean>();
}
